import React from 'react'
import styles from './FilePreview.module.scss'

const FullScreenIcon = () => {
    return (
        <svg
            className={styles.fullScreenIcon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M8 3H3v5" />
            <path d="M3 3l6 6" />

            <path d="M16 3h5v5" />
            <path d="M21 3l-6 6" />

            <path d="M8 21H3v-5" />
            <path d="M3 21l6-6" />

            <path d="M16 21h5v-5" />
            <path d="M21 21l-6-6" />
        </svg>
    )
}

export default FullScreenIcon
